import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { NavLink, useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import AdminMenu from './AdminMenu';
import PageHeader from "../components/PageCloseButton";
import { useProductContext } from "../context/productcontext";
import { toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";



////========================== To add a protected Route that only admins can access this page================

const NewProductForm = () => {
  const [data, setData] = useState({
    category: '',
    subcategory: '',
    Item: '',
    SKU: '',
    name: '',
    featured: '',
    finish: '',
    HSCode: '',
    type: '',
    size: { length: '', width: '', height: '' },
    wallDistance: '',
    outletDia: '',
    TapHole: '',
    OverFlow: '',
    weight: '',
    packing: '',
    price: '',
    star: '',
    Feature: '',
    main: '',
    featureImage: {}
  });

  const { categories, subcategories } = useProductContext();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null); // ✅ for main image upload
  const [previewMainImage, setPreviewMainImage] = useState(null); // ✅ for main preview


  const [featureFiles, setFeatureFiles] = useState({}); // ✅ renamed for clarity
  const [previewImages, setPreviewImages] = useState({});

  // ✅ Handle all feature images
  const handleImageChange = (e) => {
    const { id, files } = e.target;
    if (files && files[0]) {
      const file = files[0];


      setFeatureFiles((prev) => ({
        ...prev,
        [id]: file,
      }));


      const previewURL = URL.createObjectURL(file);
      setPreviewImages((prev) => ({
        ...prev,
        [id]: previewURL,
      }));
    }
  };

  // ✅ Main image upload handler
  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const preview = URL.createObjectURL(file);
      setPreviewMainImage(preview); // for preview
    }
  };


  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "category") {
      setData((prev) => ({
        ...prev,
        category: value,
        subcategory: "", // reset when category changes
      }));
      return;
    }
    setData((prev) => ({
      ...prev,
      [id]: toTitleCase(value),
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      let uploadedImageUrl = '';
      let uploadedFeatureImages = {};

      if (selectedFile) {
        const formData = new FormData();
        formData.append('profile', selectedFile);


        // const uploadRes = await fetch('http://localhost:8080/api/upload', {
        const uploadRes = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/upload`, {
          method: 'POST',
          body: formData,
        });


        if (!uploadRes.ok) {
          throw new Error('Image upload failed');
        }


        const uploadData = await uploadRes.json();
        uploadedImageUrl = uploadData.imageUrl;
      }
      // Upload featureImages one by one


      // console.log("Selected feature images:", featureFiles);
      for (const key of ['front', 'back', 'side', 'top', 'bottom', 'packaging']) {
        
        if (featureFiles[key]) {
          const fd = new FormData();
          fd.append('profile', featureFiles[key]);
          const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/upload`, {
            method: 'POST',
            body: fd,
          });
          const data = await res.json();
          console.log(res);
          uploadedFeatureImages[key] = data.imageUrl;


        }
      }
      console.log("Uploaded Feature Images:", uploadedFeatureImages);
      // Add image URL to product data

      console.log("featureFiles:", featureFiles);
console.log("Uploaded Feature Images:", uploadedFeatureImages);
      const productData = {
        ...data,
        main: uploadedImageUrl,
        featureImage: uploadedFeatureImages
      };
      console.log("Product Data:", productData);

      const response = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData),
      });

      const result = await response.json();
      console.log("Backend:", result);

      if (!response.ok) {
        toast.error(result.message || "Product cannot be added");
  return;
      }


      
      toast.success('Product added successfully');
      navigate('/adminproduct')
      // console.log('Product added:', result);


    } catch (error) {
      // console.error('form', error);
      toast.error('Product failed')
    }
  };


  return (
    <Wrapper>
      <Toaster position='top-center' reverseOrder={false}></Toaster>
      <div className="grid grid-two-column">
        <AdminMenu />
        <div className="main-container" >
          <PageHeader title="Create Product " />         
            <form onSubmit={handleSubmit} autoComplete="off">              
              <div className="product-container" >
                <div className="product-details">
                  <h3>Product Attributes</h3>

                  <label htmlFor="category">Category</label>

                  <select
                    id="category"
                    value={data.category}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        category: e.target.value,
                        subcategory: "", // Reset subcategory
                      }));
                    }}
                  >
                    <option value="">Select Category</option>

                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.label}
                      </option>
                    ))}
                  </select>
                   <label htmlFor="subcategory">Sub-Category</label>
                  <select
                    id="subcategory"
                    value={data.subcategory}
                    onChange={handleChange}
                  >
                    <option value="">Select Subcategory</option>

                    {subcategories
                      .filter((sub) => {
                        if (!data.category) return false;
                        return sub.category?._id === data.category;
                      })
                      .map((sub) => (
                        <option key={sub._id} value={sub._id}>
                          {sub.label}
                        </option>
                      ))}
                  </select>

                  <label htmlFor="Item">Item</label>
                  <input
                  
                    type="text"
                    id="Item"
                    value={data.Item}
                    onChange={handleChange}
                    placeholder="Item"
                    autoComplete="on"
                  />


                  <label htmlFor="SKU">SKU</label>
                  <input
                    type="text"
                    id="SKU"
                    value={data.SKU}
                    onChange={handleChange}
                    placeholder="SKU"
                    style={{ textTransform: "uppercase" }}
                  />

                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    value={data.name}
                    onChange={handleChange}
                    placeholder="Name"
                    style={{ textTransform: "uppercase" }}
                  />

                  <label htmlFor="finish">Finish</label>
                  <input
                    type="text"
                    id="finish"
                    value={data.finish}
                    onChange={handleChange}
                    placeholder="Finish"
                    autoComplete="on"
                  />

                  <label htmlFor="HSCode">H.S.Code</label>
                  <input
                    type="text"
                    id="HSCode"
                    value={data.HSCode}
                    onChange={handleChange}
                    placeholder="H.S.Code"
                    autoComplete="on"
                  />

                  <label htmlFor="packing">Packing</label>
                  <input
                    type="text"
                    id="packing"
                    value={data.packing}
                    onChange={handleChange}
                    placeholder="Packing"
                    autoComplete="on"
                  />

                  <label htmlFor="price">Price</label>
                  <input
                    type="text"
                    id="price"
                    value={data.price}
                    onChange={handleChange}
                    placeholder="price"
                  />
                  <label htmlFor="star">Star</label>
                  <input
                    type="text"
                    id="star"
                    value={data.star}
                    onChange={handleChange}
                    placeholder="star"
                  />

                  <label htmlFor="featured" className="featured-label">
                    Featured :
                    <input
                      type="checkbox"
                      id="Featured"
                      name="featured"
                      checked={data.featured}
                      onChange={(e) =>
                        setData({
                          ...data,
                          featured: e.target.checked,  // ✅ store true/false
                        })
                      }
                    />
                    <span className="featured-value">
                      {data.featured ? "True" : "False"}
                    </span>
                  </label>
                </div>

                <div className="product-details">
                  <h3>Product Key Features</h3>

                  <label htmlFor="type">Type</label>
                  <input
                    type="text"
                    id="type"
                    value={data.type}
                    onChange={handleChange}
                    placeholder="Installation Type"
                    autoComplete="on"
                  />

                  <label htmlFor="size-array">Size</label>
                  <label htmlFor="length">Length</label>
                  <input
                    type="number"
                    id="length"
                    value={data.size?.length || ""}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        size: { ...prev.size, length: e.target.value }
                      }))
                    }
                  />

                  <label htmlFor="width">Width</label>
                  <input
                    type="number"
                    id="width"
                    value={data.size?.width || ""}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        size: { ...prev.size, width: e.target.value }
                      }))
                    }
                  />

                  <label htmlFor="height">Height</label>
                  <input
                    type="number"
                    id="height"
                    value={data.size?.height || ""}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        size: { ...prev.size, height: e.target.value }
                      }))
                    }
                  />

                  <label htmlFor="size-array">Wall Distance</label>
                  <input
                    type="text"
                    id="wallDistance"
                    value={data.wallDistance}
                    onChange={handleChange}
                    placeholder="Wall Distance"
                  />

                  <label htmlFor="size-array">Outlet Dia</label>
                  <input
                    type="text"
                    id="outletDia"
                    value={data.outletDia}
                    onChange={handleChange}
                    placeholder="Outlet Dia"
                  />

                  <label htmlFor="size-array">Tap Hole</label>
                  <input
                    type="text"
                    id="TapHole"
                    value={data.TapHole}
                    onChange={handleChange}
                    placeholder="Tap Hole"
                  />


                  <label htmlFor="size-array">OverFlow</label>
                  <input
                    type="text"
                    id="OverFlow"
                    value={data.OverFlow}
                    onChange={handleChange}
                    placeholder="OverFlow"
                  />

                  <label htmlFor="weight">Weight</label>
                  <input
                    type="text"
                    id="weight"
                    value={data.weight}
                    onChange={handleChange}
                    placeholder="weight"
                  />

                  <label htmlFor="Feature">Feature</label>
                  <input
                    type="text"
                    id="Feature"
                    value={data.Feature}
                    onChange={handleChange}
                    placeholder="Feature"
                    autoComplete="on"
                  />
                  <div />
                </div>

                <div className="product-details">
                  <h3>Image</h3>
                  <div className="image-array">
                    <label htmlFor="image">main</label>
                    <input
                      type="file"
                      id="main"
                      accept="image/*" onChange={handleMainImageChange}
                    />
                    <img src={previewMainImage} alt="main Preview" width={100} />
                  </div>
                   <div className="image-array">
                    <label htmlFor="featureImage.top">Top</label>
                    <input
                      type="file"
                      id="top"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.top} alt="top Preview" width={100} />
                  </div>

                  <div className="image-array">
                    <label htmlFor="featureImage.bottom">Bottom</label>
                    <input
                      type="file"
                      id="bottom"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.bottom} alt="bottom Preview" width={100} />
                  </div>
                  <div className="image-array">
                    <label htmlFor="featureImage.side">Side</label>
                    <input
                      type="file"
                      id="side"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.side} alt="side Preview" width={100} />
                  </div>                 


                  <div className="image-array">
                    <label htmlFor="featureImage.front">Front</label>
                    <input
                      type="file"
                      id="front"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.front} alt="Front Preview" width={100} />
                  </div>

                  <div className="image-array">
                    <label htmlFor="featureImage.back">Back</label>
                    <input
                      type="file"
                      id="back"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.back} alt="back Preview" width={100} />
                  </div>
                  <div className="image-array">
                    <label htmlFor="featureImage.packaging">Packaging</label>
                    <input
                      type="file"
                      id="packaging"
                      accept="image/*" onChange={handleImageChange}
                    />
                    <img src={previewImages.packaging} alt="Packaging Preview" width={100} />
                  </div>
                  <div />

                </div>
              </div>

              <div className="two-button">
                <NavLink to='/adminproduct'>
                  <Button className="btn btn-two" type="button">
                    Cancel
                  </Button>
                </NavLink>
                <Button type="submit">Add</Button>
            </div>

          </form>
        </div>
      </div>
    </Wrapper>
  );
};


const Wrapper = styled.section`
background: #fff;
justify-content: center;

.grid-two-column{
    display: grid;
    grid-template-columns: 2fr 8fr; 
    gap: 2rem;
    }

.main-container{
    padding: 2rem;   
   }
 
.product-container{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap:3rem;
    margin: 3rem auto;
    padding:2rem;
    border-radius: 1rem;
    background-color:${({ theme }) => theme.colors.bg};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

img {
    margin-top: 10px;
    border-radius: 8px;
    }  
   
.featured-label {
      display: flex;
      align-items: center;
      gap: 3rem;
      color: #333;
      font-size: 12px;
      margin-top: 2rem;
      }

.featured-label input[type="checkbox"] {
      width: 2.5rem;
      height: 2.5rem;
      accent-color: #007bff; /* modern browsers */
      cursor: pointer;
    }

.featured-value {
      font-weight: 600;
      color: #007bff;
      font-size: 15px;
      }

.two-button Button{
    margin: 1rem;
    width : 12rem;
  } 
    
@media (max-width: ${({ theme }) => theme.media.mobile}){
  
.grid-two-column{
    grid-template-columns:1fr; 
    }

.product-container{
    display : block;
    margin:1rem;
    gap:2rem;
    padding:0rem;
    }
  
.product-details{
   margin: 1rem;  
    }

.two-button Button{
    width:10rem;
    }

  }    
`;


export default NewProductForm;
